"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M14.328 19.157l3.212 4.283L19.46 22 2.96 0 1.04 1.44l2.588 3.45a6 6 0 00.13 8.353L12 21.485l2.328-2.328zM20.243 13.243l-2.486 2.486L8.212 3.004A5.978 5.978 0 0112 4.528a6 6 0 018.243 8.715z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;